export default "__VITE_ASSET__Yx6A5KHq__";